import { cx, toDataAttrs } from '../lib/cx';
import { Video } from './Image';

export default function Hero({
  id,
  className,
  data,
  video,
  cover,
  children,
}) {
  return (
    <section id={id} className={cx('region section-screen-h theme', className)} {...toDataAttrs(data)}>
      {children}
      {cover}
      {video ? (
        <div className="video-wrapper">
          <Video src={video.src} playbackRate={video.playbackRate || 0.7} />
        </div>
      ) : null}
    </section>
  );
}
